<template>
  <EditorDeckModalsNewFeatureFound
    v-if="requestSettings.status === 'not-setup'"
    :showing="showing"
    :company-id="deck.company_id"
    @update:showing="$emit('update:showing', $event)"
  />
  <EditorDeckModalsBookMeetingDeactivated
    v-else-if="requestSettings.status === 'none-available'"
    :showing="showing"
    @activate-book-a-meeting="$emit('activate-book-a-meeting', currentUser)"
    @update:showing="!$event && $emit('update:showing', $event)"
  />
  <EditorDeckModalsCreateBookMeeting
    v-else
    :deck="deck"
    :showing="showing"
    :request-settings="requestSettings"
    @add-meeting-slide="$emit('add-meeting-slide', $event)"
    @activate-book-a-meeting="$emit('activate-book-a-meeting', currentUser)"
    @update:showing="$emit('update:showing', $event)"
  />
</template>

<script lang="ts" setup>
import type { DeepReadonly } from 'vue'
import type { BookMeetingStatus, BookMeetingState, BookMeetingNoneAvailable } from '@/composables/useBookMeeting'
import type { EditDeck } from '@/composables/useEditDeck'

const props = defineProps({
  requestSettings: {
    type: Object as PropType<DeepReadonly<BookMeetingStatus>>,
    required: true,
  },
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  showing: {
    type: Boolean,
    required: true,
  },
})

defineEmits(['activate-book-a-meeting', 'update:showing', 'add-meeting-slide'])

const currentUser = computed(() => (props.requestSettings as BookMeetingNoneAvailable | BookMeetingState).currentUser)
</script>
